/* eslint-disable indent */
const { FILE_ROLE } = require('../api/constants');

function isDeleted(o) {
    if (!o) return false;
    return o.status && (o.status == "deleted" || o.status == "gone");
}

function is_user_registered(u) {
  let us = u && u.status;
  if (!us) return false;
  return ["ghost", "initial"].indexOf(us) == -1;
}

function userHasPerm(user, perm) {
  if (!user) return false;

  if (user.is_company_admin) return true;

  if (!perm || !(_.isString(perm) || _.isArray(perm))) return false;

  const perms = _.get(user, ['company', 'profile', 'user_perms', user.user_id], null);

  if (!perms) return false;

  const _perm = _.isString(perm) ? [perm] : perm;

  return _.intersection(perms, _perm).length > 0;
}

function capitalize(s) {
  return (typeof s !== 'string')
    ? ''
    : s.charAt(0).toUpperCase() + s.slice(1);
}

function prettyName(name, email) {
    let pName = null;

    if (name) {
        pName = name;
        if (email) {
            pName += ` (${email})`;
        }
    } else if (email) {
        pName = email;
    }

    return pName;
}

/* source: api/controllers/api/0.3/base.js */
function cleanPath(path, nojoin) {
    let cp = path.split("/").map(p => p.replace(/#.*$/g, ''));
    return nojoin ? cp : cp.join('/');
}

function clean_file(file) {
  const allowed_fields = [
    'id',
    'file_id',
    'name',
    'url',
    'mime_type',
    'file_size',
    'is_annotatable',
    'annotation',
    'page_count',
    'flags',
    'metadata'
  ];

  const r = allowed_fields.reduce((a, f) => {
    if (file[f] !== undefined && file[f] !== null) a[f] = file[f];
    return a;
  }, {});

  if (file.auto_ctime) r.upload_time = file.auto_ctime;
  return r;
}

function escapeTags(text) {
  if (!text) return text;

  return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

// https://builds.atlassian.net/browse/SUB-401
// https://stackoverflow.com/a/8943487
function linkify(text, editable) {
  if (!text) return text;

  let urlRegex =/(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

  return text.replace(urlRegex, url => {
    return editable
      ? '<a href="#" style="cursor: pointer;" onClick="window.open(\''+url + '\',\'_blank\')">' + url + '</a>'
      : '<a target="_blank" href="' + url + '">' + url + '</a>';
  });
}

function isSpecBook(file, projectData) {
  if (!file) return false;
  let isProjectDataSpec = _.get(projectData, 'specbooks', {})[file.file_id];

  return isProjectDataSpec || file.role && file.role == FILE_ROLE.SPECBOOK;
}

module.exports = {
  isDeleted,
  is_user_registered,
  userHasPerm,
  capitalize,
  prettyName,
  cleanPath,
  clean_file,
  escapeTags,
  linkify,
  isSpecBook
};
